import { render, staticRenderFns } from "./companyTab.vue?vue&type=template&id=6a9c0718"
import script from "./companyTab.vue?vue&type=script&lang=js"
export * from "./companyTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a9c0718')) {
      api.createRecord('6a9c0718', component.options)
    } else {
      api.reload('6a9c0718', component.options)
    }
    module.hot.accept("./companyTab.vue?vue&type=template&id=6a9c0718", function () {
      api.rerender('6a9c0718', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/cpy/companyTab.vue"
export default component.exports